// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"394":"d796ef3a","683":"1776dba6"}[chunkId] + ".chunk.js";
};